import React from "react";
import { Typography, Grid, Box, Button } from "@mui/material";
import "./food.css";

const Food = ({ nextStep, prevStep }) => {
  return (
    <Box className='forms-meeting-container'>
      <Box className='food-container'>
        {/* Title */}
        <Typography variant='h4' className='food-title' align='center'>
          Food
        </Typography>

        {/* Food Information Grid */}
        <Grid container spacing={3} justifyContent='center' mt={2} className='food-info-grid'>
          {/* Top Row */}
          <Grid item xs={12} sm={7}>
            <Box className='info-box' sx={{ backgroundColor: "#FFE4E1" }}>
              <Typography variant='body1' sx={{ fontFamily: "Comic Sans MS", color: "#FF5722" }}>
                Food is a really important part of everyone's life.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={5}>
            <Box className='info-box' sx={{ backgroundColor: "#E8F5E9" }}>
              <Typography variant='body1' sx={{ fontFamily: "Comic Sans MS", color: "#43A047" }}>
                You have the right to a diet that fits in with your taste, culture, and religion.
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={3} justifyContent='center' mt={1} className='food-info-grid'>
          {/* Middle Row */}
          <Grid item xs={12} sm={5}>
            <Box className='info-box' sx={{ backgroundColor: "#FFF3E0" }}>
              <Typography variant='body1' sx={{ fontFamily: "Comic Sans MS", color: "#FF9800" }}>
                The home has weekly menus in place.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={7}>
            <Box className='info-box' sx={{ backgroundColor: "#E1F5FE" }}>
              <Typography variant='body1' sx={{ fontFamily: "Comic Sans MS", color: "#0288D1" }}>
                Exercising is also important.
              </Typography>
            </Box>
          </Grid>

          {/* Bottom Row */}
          <Grid item xs={12} sm={8}>
            <Box className='left-info-box' sx={{ backgroundColor: "#F1F8E9" }}>
              <Typography variant='body1' sx={{ fontFamily: "Comic Sans MS", color: "#558B2F" }}>
                You can help staff choose which meals to have on the menu.
              </Typography>
            </Box>

            <Box className='left-info-box' sx={{ backgroundColor: "#F5F5F5" }} mt={1}>
              <Typography variant='body1' sx={{ fontFamily: "Comic Sans MS", color: "#9E9E9E" }}>
                To make sure you are being offered a varied and healthy balanced diet
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Box className='right-info-box' sx={{ backgroundColor: "#FFEBEE" }}>
              <Typography variant='body1' sx={{ fontFamily: "Comic Sans MS", color: "#D32F2F" }}>
                You will be offered to take part in a range of activities to help you keep fit.
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Favorite Foods Section */}
        <Box mt={3} sx={{ backgroundColor: "#E1F5FE", p: 2, height: 100 }}>
          <Typography variant='h6' sx={{ fontFamily: "Comic Sans MS", color: "#1976d2" }}>
            My favorite foods are
          </Typography>
        </Box>
        <Grid container justifyContent='space-between' alignItems='center' mt={2}>
          <Grid item>
            <Button type='button' variant='contained' color='primary' onClick={prevStep}>
              Previous
            </Button>
          </Grid>
          <Grid item>
            <Button type='button' variant='contained' color='primary' onClick={nextStep}>
              Next
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box className='bottom-food' mr={3}>
        <img src='./CYPImages/food.png' alt='Bottom Character' className='bottom-food-image' />
      </Box>
    </Box>
  );
};

export default Food;
